#!/usr/bin/env node

import { runCli } from "./cli/runner.js";

const exitCode = await runCli(process.argv.slice(2), {
  cwd: process.cwd(),
  stdin: process.stdin,
  stdout: process.stdout,
  stderr: process.stderr,
  env: process.env,
});

process.exit(exitCode);
